import React from "react"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom"
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import "./App.css"
import HeroSection from "./components/HeroSection"
import CalendarSection from "./components/CalendarSection"
import CallAgenda from "./components/CallAgenda"
import AboutCordovaSimple from "./components/AboutCordovaSimple"
import TiredSection from "./components/TiredSection"
import ProvenFranchise from "./components/ProvenFranchise"
import AboutCordova from "./components/AboutCordova"
import MythBusters from "./components/MythBusters"
import ValueProposition from "./components/ValueProposition"
import DiscoveryCTA from "./components/DiscoveryCTA"
import FranchiseOfferings from "./components/FranchiseOfferings"
import TerritoryMap from "./components/TerritoryMap"
import HowItWorks from "./components/HowItWorks"
import FAQ from "./components/FAQ"
import Footer from "./components/Footer"
import PrivacyPolicy from "./components/PrivacyPolicy"
import TermsOfService from "./components/TermsOfService"
import ThankYou from "./components/ThankYou"

// Home page component
const HomePage = () => (
  <div className='App'>
    <HeroSection />
    <CalendarSection />
    <CallAgenda />
    <AboutCordovaSimple />
    <TiredSection />
    <ProvenFranchise />
    <AboutCordova />
    <TerritoryMap />
    <MythBusters />
    <ValueProposition />
    <DiscoveryCTA />
    <FranchiseOfferings />
    <HowItWorks />
    <FAQ />
    <Footer />
  </div>
)

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Navigate to='/booking' replace />} />
          <Route path='/booking' element={<HomePage />} />
          <Route path='/privacy' element={<PrivacyPolicy />} />
          <Route path='/terms' element={<TermsOfService />} />
          <Route path='/thank-you' element={<ThankYou />} />
        </Routes>
      </Router>
      <Analytics />
      <SpeedInsights />
    </>
  )
}

export default App
